import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

/*
 Compatibility shim for the react-router v5 withRouter HOC. Injects the
 v5-shaped location/history/match props that class components consume.
*/
export default function withRouter(Component) {
  function ComponentWithRouterProps(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const history = {
      push: (to, state) => navigate(to, { state }),
      replace: (to, state) => navigate(to, { replace: true, state }),
      goBack: () => navigate(-1),
      go: (n) => navigate(n),
      location,
    };
    return (
      <Component
        {...props}
        location={location}
        history={history}
        match={{ params }}
      />
    );
  }
  return ComponentWithRouterProps;
}
